import { render, staticRenderFns } from "./ContratoSalud.vue?vue&type=template&id=78318046&scoped=true&"
import script from "./ContratoSalud.vue?vue&type=script&lang=js&"
export * from "./ContratoSalud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78318046",
  null
  
)

export default component.exports